(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3669],{

/***/ 2982:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kataloog/[[...kategooria]]",
      function () {
        return __webpack_require__(4394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4337);
/* harmony import */ var _UI_ProductCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(681);
/* harmony import */ var _UI_ProductCard_MobileProductCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1459);
/* harmony import */ var _UI_Skeletons_SkeletonProductCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3327);
/* harmony import */ var _UI_Skeletons_MobileSkeletonProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2298);
/* harmony import */ var hooks_products_useCatalogue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4457);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function Products(param) {
    var products = param.products;
    var items = products === null || products === void 0 ? void 0 : products.filter(function(item) {
        return item;
    });
    var numArray = _toConsumableArray(Array(24));
    var loading = (0,hooks_products_useCatalogue__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                display: {
                    _: "none",
                    desktop: "grid"
                },
                gridTemplateColumns: "repeat(3, 33.33%)",
                columnGap: "1rem",
                rowGap: "2rem",
                p: "1.5rem 1rem 0 0",
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: numArray.map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Skeletons_SkeletonProductCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}, i);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: items === null || items === void 0 ? void 0 : items.map(function(product) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_ProductCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            product: product,
                            imageSize: {
                                width: 180,
                                height: 200
                            }
                        }, product.sku);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                display: {
                    _: "grid",
                    desktop: "none"
                },
                gridTemplateColumns: {
                    _: "1fr",
                    lg_tablet: "1fr 1fr"
                },
                justifyItems: {
                    sm_tablet: "center"
                },
                columnGap: "0.75rem",
                rowGap: "0.1rem",
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: numArray === null || numArray === void 0 ? void 0 : numArray.map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Skeletons_MobileSkeletonProductCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            // product={product}
                            maxW: 450,
                            minH: 150
                        }, i);
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: items === null || items === void 0 ? void 0 : items.map(function(product) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_ProductCard_MobileProductCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            product: product,
                            maxW: 450,
                            minH: 150
                        }, product.sku);
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 9999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Sort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 3 modules
var react_select_esm = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./global/data.js + 2 modules
var data = __webpack_require__(6863);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/Catalogue/Sort/SortSelect.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  z-index: 2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledSelect = (0,styled_components_esm/* default */.ZPm)(react_select_esm/* default */.ZP)(_templateObject());
function SortSelect() {
    var ref = _slicedToArray((0,esm/* useAtom */.KO)(store/* sortAtom */.xe), 2), sort = ref[0], setSort = ref[1];
    var router = (0,next_router.useRouter)();
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        setSort(data/* sortOptions */.Fo["".concat(router.locale)].content);
    }, []);
    var handleSortSelect = function(selection) {
        return setSort(selection);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
        name: "sort",
        placeholder: t("ui.choose"),
        options: data/* sortOptions */.Fo["".concat(router.locale)].content,
        defaultValue: data/* sortOptions */.Fo["".concat(router.locale)].content[0],
        value: sort,
        onChange: handleSortSelect,
        styles: {
            control: function(base) {
                return _objectSpread({}, base, {
                    width: "170px",
                    borderRadius: "10px",
                    background: "#FCFCFC",
                    boxShadow: "none",
                    border: "2px solid #A8A9BA",
                    "&:focus": {
                        border: "2px solid #A8A9BA"
                    },
                    "&:hover": {
                        border: "2px solid #A8A9BA"
                    },
                    "@media (max-width: 1024px)": {
                        border: "none",
                        background: "white",
                        "&:focus": {
                            border: "none"
                        },
                        "&:hover": {
                            border: "none"
                        }
                    }
                });
            },
            indicatorSeparator: function() {
                return {
                    display: "none"
                };
            },
            dropdownIndicator: function(base, state) {
                return _objectSpread({}, base, {
                    transform: state.selectProps.menuIsOpen ? "scale(1.4) rotate(180deg)" : "scale(1.4)",
                    color: "#393939",
                    cursor: "pointer",
                    transition: "all 0.5s",
                    "&:hover": {
                        color: "inherit"
                    }
                });
            },
            option: function(base, state) {
                return _objectSpread({}, base, {
                    background: state.isSelected ? "#F6F6FF" : "white",
                    color: "black",
                    cursor: "pointer",
                    "&:hover": {
                        background: "#F6F6FF",
                        color: "black"
                    }
                });
            },
            menuList: function(base) {
                return _objectSpread({}, base, {
                    paddingTop: "0",
                    paddingBottom: "0"
                });
            }
        }
    });
};

// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./components/UI/Icons/Catalogue/index.js
var Catalogue = __webpack_require__(5862);
;// CONCATENATED MODULE: ./components/Catalogue/Sort/index.js






function Sort() {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        align: "center",
        justify: {
            _: "flex-start",
            mobile: "center"
        },
        spaceX: {
            _: "0",
            desktop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                display: {
                    desktop: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "img",
                    "aria-label": "Filter products",
                    children: Catalogue/* FilterBoxArrows */.HZ
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    " \xa0 ",
                    t("filter.sort"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortSelect, {})
        ]
    });
};


/***/ }),

/***/ 3862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CatalogueContainer; },
/* harmony export */   "O": function() { return /* binding */ ResultsContainer; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5653);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 224px;\n\n  .filter {\n    display: inline-flex;\n    align-items: center;\n\n    svg {\n      transform: scale(1.5);\n    }\n  }\n\n  @media (max-width: desktop) {\n    padding: 0 1rem;\n\n    h3 span {\n      display: none;\n    }\n  }\n\n  @media (min-width: desktop) {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  margin-top: 1rem;\n\n  @media (min-width: desktop) {\n    width: 72%;\n    margin-top: 3rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CatalogueContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section */ .ZPm.section(_templateObject());
var ResultsContainer = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZPm)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_0__/* .FlexBox */ .h)(_templateObject1());


/***/ }),

/***/ 2524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BreadCrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4337);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5653);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1028);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n\n  a {\n    color: #959595;\n    &:hover {\n      color: gray-300;\n    }\n  }\n\n  span {\n    position: relative;\n    bottom: 0.2rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Crumbs = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZPm)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__/* .FlexBox */ .h)(_templateObject());
function BreadCrumbs(param) {
    var crumbs = param.crumbs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
        display: {
            _: "none",
            desktop: "inline"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Crumbs, {
                spaceX: 10,
                children: crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(function(crumb, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                        spaceX: 10,
                        children: [
                            i > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                role: "img",
                                "aria-label": "Sequence arrow",
                                children: SequenceArrow
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: crumb.path,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: crumb.name
                                })
                            })
                        ]
                    }, crumb.path);
                })
            })
        })
    });
};
var SequenceArrow = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9.114",
    height: "4.48",
    viewBox: "0 0 9.114 4.48",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        id: "Icon_awesome-long-arrow-alt-right",
        "data-name": "Icon awesome-long-arrow-alt-right",
        d: "M6.387,11.684H.244A.244.244,0,0,0,0,11.929v1.139a.244.244,0,0,0,.244.244H6.387v.937a.488.488,0,0,0,.834.345l1.751-1.751a.488.488,0,0,0,0-.691L7.22,10.4a.488.488,0,0,0-.834.345Z",
        transform: "translate(0 -10.258)",
        fill: "#959595"
    })
});


/***/ }),

/***/ 517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4337);
/* harmony import */ var _UI_Button_Variants_Monochrome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7013);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5653);





var ErrorLayout = function(param) {
    var statusCode = param.statusCode, title = param.title, text = param.text, image = param.image;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__/* .FlexBox */ .h, {
            as: "section",
            w: "100%",
            minH: "80vh",
            justify: "center",
            backgroundImage: "url(/images/error_page_bg.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: {
                _: "center",
                desktop: "left -300px center"
            },
            backgroundSize: {
                _: "cover",
                desktop: "initial"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__/* .FlexBox */ .h, {
                dir: "column",
                align: "center",
                mt: 64,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                        as: "h1",
                        fontSize: 74,
                        fontWeight: 700,
                        color: "gray-300",
                        children: statusCode
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                        as: "span",
                        role: "img",
                        "aria-label": text,
                        mt: 96,
                        children: image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_Variants_Monochrome__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        p: "8px 72px",
                        mt: 72,
                        onClick: function() {
                            return router.push("/");
                        },
                        children: "Tagasi avalehele"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 5990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7248);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9430);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1040);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  padding: ",
        ";\n  margin-right: 0.75rem;\n  width: 15px;\n  height: 15px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  background-color: ",
        ";\n  outline: ",
        ";\n  cursor: pointer;\n\n  svg {\n    position: absolute;\n    visibility: ",
        ";\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var CheckboxContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].labelBox */ .ZPm.labelBox(_templateObject());
var HiddenCheckbox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input.attrs */ .ZPm.input.attrs({
    type: "checkbox"
})(_templateObject1(), _utils__WEBPACK_IMPORTED_MODULE_3__/* .HideInput */ .x1);
var StyledCheckbox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZPm.div(_templateObject2(), function(param) {
    var hidden = param.hidden;
    return hidden ? "none" : "inline-flex";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0.5rem 0.6rem 0.6rem";
}, _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__.th.color("purple-200"), function(param) {
    var checked = param.checked;
    return checked ? _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__.th.color("purple-200") : "white";
}, function(param) {
    var checked = param.checked;
    return checked && "none";
}, function(param) {
    var checked = param.checked;
    return checked ? "visible" : "hidden";
}, function(param) {
    var padding = param.padding;
    return padding === 0 && "scale(0.7)";
});
var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CheckboxContainer, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HiddenCheckbox, {
                ref: ref,
                name: props.name,
                checked: props.value,
                onChange: props.onChange
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCheckbox, {
                hidden: props.hideBox ? 1 : null,
                checked: props.value,
                padding: props.padding,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_2__/* .Checkmark */ .MC, {
                    width: "2"
                })
            }),
            props.label,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                position: "absolute",
                top: "3rem",
                left: "2rem",
                children: props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils__WEBPACK_IMPORTED_MODULE_3__/* .ErrorMessage */ .Bc, {
                    children: props.error.message
                })
            })
        ]
    }));
});
Checkbox.displayName = "Checkbox";
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 7646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7248);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1040);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 0.75rem;\n  width: 20px;\n  height: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  outline: ",
        ";\n  cursor: ",
        ";\n\n  &:after {\n    position: absolute;\n    content: '';\n    width: 6px;\n    height: 6px;\n    background-color: white;\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var RadioButtonContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label */ .ZPm.label(_templateObject());
var HiddenRadioButton = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.attrs */ .ZPm.input.attrs({
    type: "radio"
})(_templateObject1(), _utils__WEBPACK_IMPORTED_MODULE_2__/* .HideInput */ .x1);
var StyledRadioButton = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZPm.div(_templateObject2(), _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__.th.color("purple-200"), function(param) {
    var checked = param.checked;
    return checked ? _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_4__.th.color("purple-200") : "white";
}, function(param) {
    var checked = param.checked;
    return checked && "none";
}, function(param) {
    var disabled = param.disabled;
    return !disabled && "pointer";
});
var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var checked = props.checked === props.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RadioButtonContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HiddenRadioButton, {
                ref: ref,
                name: props.name,
                value: props.value,
                checked: checked,
                onChange: props.onChange,
                disabled: props.disabled
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledRadioButton, {
                checked: checked,
                disabled: props.disabled
            }),
            props.label
        ]
    });
});
RadioButton.displayName = "RadioButton";
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 4457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCatalogue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3359);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var graphql_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4462);
/* harmony import */ var utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4244);
/* harmony import */ var _useProductPages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8812);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useCatalogue() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var lang = router.locale ? router.locale : "et";
    // Get category url slug
    var categorySlug = router.asPath.split("/").pop().split("?")[0];
    // Get category ID
    var id = (options === null || options === void 0 ? void 0 : options.categoryId) || (0,utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(categorySlug);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), productCount = ref6[0], setProductCount = ref6[1];
    var pageSize = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .pageSizeAtom */ .Gx);
    var currentPage = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .currentPageAtom */ .ef);
    var ref1 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .sortAtom */ .xe), sortBy = ref1.value;
    var ref2 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .filtersAtom */ .ot), price = ref2.price, brand = ref2.brand, // Other filter values here
    v__rv = ref2.v__rv;
    // Get category products
    var ref3 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .useLazyQuery */ .t)(graphql_queries__WEBPACK_IMPORTED_MODULE_3__/* .CATEGORY_PRODUCTS */ .h$, {
        variables: {
            id: id,
            price: price,
            brand: brand,
            // Other filter variables here
            v__rv: v__rv,
            sortBy: sortBy,
            currentPage: currentPage,
            pageSize: pageSize
        },
        context: {
            headers: {
                store: lang
            },
            fetchOptions: {
                method: "GET"
            }
        },
        fetchPolicy: "network-only",
        errorPolicy: "all",
        skip: (options === null || options === void 0 ? void 0 : options.skipQuery) || !id,
        onCompleted: function(data) {
            var ref;
            var count = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.total_count;
            if (count && productCount !== count) {
                setProductCount(count);
            }
        }
    }), 2), getProducts = ref3[0], ref4 = ref3[1], data1 = ref4.data, loading = ref4.loading, error = ref4.error;
    // Execute query on mount if not skipped
    if (id && !(options === null || options === void 0 ? void 0 : options.skipQuery) && !data1 && !loading) {
        getProducts();
    }
    var ref5 = (0,_useProductPages__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(getProducts, data1), products = ref5.products, pages = ref5.pages;
    return {
        products: products,
        loading: loading && !(options === null || options === void 0 ? void 0 : options.skipQuery),
        error: error,
        pages: pages,
        count: productCount
    };
};


/***/ }),

/***/ 4394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _kategooria_Catalogue; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./hooks/products/useCatalogue.js
var useCatalogue = __webpack_require__(4457);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(1641);
// EXTERNAL MODULE: ./graphql/queries/index.js + 28 modules
var queries = __webpack_require__(4462);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./hooks/products/useCategoryBreadcrumbs.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var mapQueryCategories = function(data) {
    var ref;
    var categoryData = data === null || data === void 0 ? void 0 : data.categoryList[0];
    var parentCategory = {
        name: categoryData === null || categoryData === void 0 ? void 0 : categoryData.name,
        path: categoryData === null || categoryData === void 0 ? void 0 : categoryData.url_key
    };
    var breadcrumbs = categoryData === null || categoryData === void 0 ? void 0 : (ref = categoryData.breadcrumbs) === null || ref === void 0 ? void 0 : ref.map(function(crumb) {
        return {
            name: crumb.category_name,
            path: crumb.category_url_key
        };
    });
    var categories = [
        parentCategory,
        breadcrumbs
    ];
    var queryCategories = categories.flat().filter(function(category) {
        return category;
    });
    return queryCategories;
};
var mapBreadcrumbs = function(data, pathname, t) {
    if (data.length > 0) {
        data.push(data.shift());
        var crumbs = data.map(function(crumb) {
            var ref;
            var crumbLength = pathname.lastIndexOf(crumb.path) + (crumb === null || crumb === void 0 ? void 0 : (ref = crumb.path) === null || ref === void 0 ? void 0 : ref.length);
            var name = crumb.name;
            var path = pathname.substring(0, crumbLength);
            return {
                name: name,
                path: path
            };
        });
        var breadcrumbs = [
            {
                name: t("ui.home"),
                path: "/"
            }
        ].concat(_toConsumableArray(crumbs));
        return breadcrumbs;
    } else return null;
};
function useBreadcrumbs() {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), queryCrumbs = ref[0], setQueryCrumbs = ref[1];
    var ref1 = (0,react.useState)([]), crumbs1 = ref1[0], setCrumbs = ref1[1];
    var _query = router.query, categories = _query.kategooria;
    var query = categories === null || categories === void 0 ? void 0 : categories.slice().pop();
    var data = (0,useQuery/* useQuery */.a)(queries/* CATEGORY_NAME */._9, {
        variables: {
            name: query
        },
        context: {
            fetchOptions: {
                method: "GET"
            }
        }
    }).data;
    (0,react.useEffect)(function() {
        if (data) {
            var queryCategories = mapQueryCategories(data);
            if (queryCategories) setQueryCrumbs(queryCategories);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.categoryList
    ]);
    (0,react.useEffect)(function() {
        var path = router.asPath;
        var crumbs = mapBreadcrumbs(queryCrumbs, path, t);
        if (crumbs) setCrumbs(crumbs);
    }, [
        queryCrumbs
    ]);
    return crumbs1;
};

// EXTERNAL MODULE: ./hooks/UI/useScrollRestoration.js
var useScrollRestoration = __webpack_require__(4751);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/jotai/esm/utils.js
var utils = __webpack_require__(4824);
// EXTERNAL MODULE: ./utils/getCategoryId.js
var getCategoryId = __webpack_require__(4244);
;// CONCATENATED MODULE: ./hooks/products/useCustomFilterOptions.js




function useCustomFilterValues() {
    var ref;
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    var query = (ref = router.query) === null || ref === void 0 ? void 0 : ref.kategooria;
    var urlKey = query === null || query === void 0 ? void 0 : query.slice().pop();
    var categoryId = (0,getCategoryId/* default */.Z)(urlKey);
    var data = (0,useQuery/* useQuery */.a)(queries/* CUSTOM_ATTRIBUTE_VALUES */.Kf, {
        variables: {
            id: categoryId
        },
        context: {
            fetchOptions: {
                method: "GET"
            },
            headers: {
                store: lang
            }
        }
    }).data;
    var aggregations = data === null || data === void 0 ? void 0 : data.products.aggregations;
    return aggregations;
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./utils/getLinkPath.js
var getLinkPath = __webpack_require__(8776);
;// CONCATENATED MODULE: ./utils/parseCategories.js
function parseCategories(groups) {
    var categories = groups && JSON.parse(JSON.stringify(groups));
    var strollers = categories === null || categories === void 0 ? void 0 : categories.find(function(item) {
        return item.name === "Vankrid";
    }).children;
    if (strollers) {
        var sets = strollers === null || strollers === void 0 ? void 0 : strollers.find(function(item) {
            return item.name === "Komplektid";
        });
        var secureSets = strollers === null || strollers === void 0 ? void 0 : strollers.find(function(item) {
            return item.name === "Komplektid koos turvah\xe4lliga";
        });
        var indexOfSets = strollers === null || strollers === void 0 ? void 0 : strollers.indexOf(sets);
        var indexOfSecureSets = strollers === null || strollers === void 0 ? void 0 : strollers.indexOf(secureSets);
        delete strollers[indexOfSecureSets];
        strollers === null || strollers === void 0 ? void 0 : strollers.push(strollers === null || strollers === void 0 ? void 0 : strollers.splice(indexOfSets, 1).pop());
    }
    return categories;
};

;// CONCATENATED MODULE: ./hooks/products/useCategoryFilter.js




function useCategoryFilter(param) {
    var id = param.id, query = param.query;
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    var ref2 = (0,react.useState)([]), categories1 = ref2[0], setCategories = ref2[1];
    var ref1 = (0,useQuery/* useQuery */.a)(query, {
        variables: {
            ids: id || [
                "2"
            ]
        },
        context: {
            fetchOptions: {
                method: "GET"
            },
            headers: {
                store: lang
            }
        }
    }), data = ref1.data, loading = ref1.loading;
    (0,react.useEffect)(function() {
        var ref;
        var groups = (ref = data === null || data === void 0 ? void 0 : data.categoryList[0]) === null || ref === void 0 ? void 0 : ref.children;
        if (!id) {
            var categories = parseCategories(groups);
            setCategories(categories);
        } else {
            setCategories(groups);
        }
    }, [
        id,
        data
    ]);
    return {
        categories: categories1,
        loading: loading
    };
};

// EXTERNAL MODULE: ./components/UI/Button/index.js
var Button = __webpack_require__(8356);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
;// CONCATENATED MODULE: ./components/Catalogue/Filter/FilterType.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1.5rem;\n\n  button:hover {\n    h3 {\n      color: teal-200;\n    }\n\n    svg path {\n      fill: #45aac4;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 290px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      scrollbar-color: #96e7e7 #fafafa;\n      scrollbar-width: 10%;\n      \n      &::-webkit-scrollbar {\n        width: 10px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background-color: #fafafa;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: #96e7e7;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var FilterTypeBox = styled_components_esm/* default.div */.ZPm.div(_templateObject());
var FilterValues = styled_components_esm/* default.div */.ZPm.div(_templateObject2(), function(param) {
    var title = param.title;
    return title !== "KATEGOORIA" && (0,styled_components_esm/* css */.ivY)(_templateObject1());
});
function FilterType(param) {
    var title = param.title, children = param.children;
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var ref = (0,react.useState)(true), open1 = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)("rotate(90deg)"), rotate = ref1[0], setRotate = ref1[1];
    var toggle = function() {
        setOpen(function(open) {
            return !open;
        });
        setRotate(open1 ? rotate === "rotate(90deg)" : "rotate(-270deg)");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterTypeBox, {
        as: "form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                w: "100%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "space-between",
                pb: "1rem",
                pl: {
                    _: "1.75rem",
                    desktop: "0"
                },
                onClick: toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* CategoryTitle */.gI, {
                        fontSize: "xsmall",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "span",
                        display: {
                            _: "none",
                            desktop: "inline"
                        },
                        transform: "".concat(rotate),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Chevron */.Tt, {
                            fill: theme.colors["teal-300"]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterValues, {
                title: title,
                children: open1 && children
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Form/Checkbox.js
var Checkbox = __webpack_require__(5990);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
;// CONCATENATED MODULE: ./components/Catalogue/Filter/Attributes/Category/CategoryFilterItem.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function FilterItem(param1) {
    var label = param1.label, name = param1.name, qty = param1.qty, subItem = param1.subItem;
    var router = (0,next_router.useRouter)();
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    var ref2 = (0,react.useState)([]), selected = ref2[0], setSelected = ref2[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        var categories = [];
        if ((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.kategooria) === null || ref1 === void 0 ? void 0 : ref1.includes(name)) {
            categories.push(name);
            setSelected(categories);
        }
        var handleRouteChange = function() {
            return setSelected([]);
        };
        router.events.on("routeChangeStart", handleRouteChange);
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        justify: "space-between",
        align: "center",
        w: 240,
        lineHeight: 2,
        pl: subItem && "1.75rem",
        fontWeight: (selected === null || selected === void 0 ? void 0 : selected.includes(name)) ? 700 : 400,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                name: name,
                control: control,
                defaultValue: false,
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, _objectSpread({}, field, {
                        label: label,
                        hideBox: true,
                        padding: subItem && 0,
                        fontSize: subItem && "xxsmall",
                        color: subItem && "blue-200",
                        cursor: "pointer"
                    }));
                }
            }),
            qty && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "span",
                pl: "0.5rem",
                color: "lightgray",
                fontSize: subItem && "xxsmall",
                children: qty
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Catalogue/Filter/Attributes/Category/index.js
function Category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Category_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Category_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












function CategoryFilter() {
    var ref;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var formMethods = (0,index_esm/* useForm */.cI)();
    var queryParams = (ref = router.query) === null || ref === void 0 ? void 0 : ref.kategooria;
    var categorySlug = queryParams && queryParams[0];
    var categoryId = (0,getCategoryId/* default */.Z)(categorySlug);
    var categories = useCategoryFilter({
        id: [
            categoryId
        ],
        query: queries/* CATALOGUE_CATEGORIES */.hd
    }).categories;
    var getProductCount = function(totalCount, productCount) {
        if (totalCount > 0) {
            return totalCount > productCount ? totalCount : productCount;
        } else return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, Category_objectSpread({}, formMethods, {
        children: (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterType, {
            title: t("category.category"),
            children: categories.map(function(category) {
                var name1 = category.name, children = category.children, product_count1 = category.product_count, products1 = category.products;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        product_count1 >= 0 && name1 !== "Komplektid koos turvah\xe4lliga" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,getLinkPath/* default */.Z)(category.url_key, categorySlug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItem, {
                                    label: name1,
                                    name: category.url_key,
                                    qty: getProductCount(products1 === null || products1 === void 0 ? void 0 : products1.total_count, product_count1)
                                })
                            })
                        }),
                        children && children.map(function(subcategory) {
                            var name = subcategory.name, product_count = subcategory.product_count, products = subcategory.products;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: product_count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,getLinkPath/* default */.Z)(subcategory.url_key, category.url_key, categorySlug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItem, {
                                            label: name,
                                            name: subcategory.url_key,
                                            qty: getProductCount(products === null || products === void 0 ? void 0 : products.total_count, product_count),
                                            subItem: true
                                        })
                                    })
                                })
                            }, subcategory.url_key);
                        })
                    ]
                }, category.url_key);
            })
        })
    }));
};

// EXTERNAL MODULE: ./global/data.js + 2 modules
var data = __webpack_require__(6863);
// EXTERNAL MODULE: ./components/UI/Form/RadioButton.js
var RadioButton = __webpack_require__(7646);
;// CONCATENATED MODULE: ./components/Catalogue/Filter/Attributes/Price.js
function Price_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Price_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Price_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Price_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Price_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function Price_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Price_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Price_arrayLikeToArray(o, minLen);
}











function PriceFilter() {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var ref = _slicedToArray((0,esm/* useAtom */.KO)(store/* filtersAtom */.ot), 2), filters = ref[0], setFilters = ref[1];
    var ref1 = _slicedToArray((0,esm/* useAtom */.KO)(store/* filtersResetAtom */.Bv), 2), filtersReset = ref1[0], setFiltersReset = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, watch = ref2.watch, reset = ref2.reset, setValue = ref2.setValue;
    var priceFilter = watch("priceFilter");
    (0,react.useEffect)(function() {
        if (filters === null || filters === void 0 ? void 0 : filters.price) {
            var filter = data/* priceRanges.find */.py.find(function(item) {
                return JSON.stringify(item.value) === JSON.stringify(filters.price);
            });
            filter && setValue("priceFilter", filter === null || filter === void 0 ? void 0 : filter.name);
        }
    }, [
        filters === null || filters === void 0 ? void 0 : filters.price
    ]);
    (0,react.useEffect)(function() {
        if (filtersReset) {
            reset();
            setTimeout(function() {
                return setFiltersReset(false);
            }, 1000);
        }
    }, [
        filtersReset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterType, {
        title: t("product_main.current_price"),
        children: data/* priceRanges.map */.py.map(function(param) {
            var name = param.name, label = param.label;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                align: "center",
                justify: "space-between",
                w: 240,
                lineHeight: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, Price_objectSpread({}, register("priceFilter", {
                        onChange: function(event) {
                            var value = event.target.value;
                            var applyFilter = function(price) {
                                setFilters(Price_objectSpread({}, filters, {
                                    price: price
                                }));
                                window.scrollTo(0, 0);
                            };
                            if (value === "0-99") {
                                applyFilter({
                                    to: "99.99"
                                });
                            } else if (value === "100-199") {
                                applyFilter({
                                    from: "100",
                                    to: "199.99"
                                });
                            } else if (value === "200") {
                                applyFilter({
                                    from: "200"
                                });
                            }
                        }
                    }), {
                        label: label,
                        value: name,
                        checked: priceFilter
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "span",
                        pl: 8,
                        color: "lightgray"
                    })
                ]
            }, label);
        })
    });
};

;// CONCATENATED MODULE: ./components/Catalogue/Filter/Attributes/CustomAttribute.js
function CustomAttribute_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CustomAttribute_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CustomAttribute_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return CustomAttribute_arrayLikeToArray(arr);
}
function CustomAttribute_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomAttribute_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function CustomAttribute_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CustomAttribute_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CustomAttribute_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CustomAttribute_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomAttribute_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomAttribute_slicedToArray(arr, i) {
    return CustomAttribute_arrayWithHoles(arr) || CustomAttribute_iterableToArrayLimit(arr, i) || CustomAttribute_unsupportedIterableToArray(arr, i) || CustomAttribute_nonIterableRest();
}
function CustomAttribute_toConsumableArray(arr) {
    return CustomAttribute_arrayWithoutHoles(arr) || CustomAttribute_iterableToArray(arr) || CustomAttribute_unsupportedIterableToArray(arr) || CustomAttribute_nonIterableSpread();
}
function CustomAttribute_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CustomAttribute_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CustomAttribute_arrayLikeToArray(o, minLen);
}










function CustomAttributeFilter(param1) {
    var title = param1.title, attribute = param1.attribute, options = param1.options;
    var sortedOptions = options === null || options === void 0 ? void 0 : options.sort(function(a, b) {
        return a.label.localeCompare(b.label);
    });
    var ref4 = CustomAttribute_slicedToArray((0,esm/* useAtom */.KO)(store/* filtersAtom */.ot), 2), filters = ref4[0], setFilters = ref4[1];
    var ref1 = CustomAttribute_slicedToArray((0,esm/* useAtom */.KO)(store/* filtersResetAtom */.Bv), 2), filtersReset = ref1[0], setFiltersReset = ref1[1];
    var ref2 = CustomAttribute_slicedToArray((0,esm/* useAtom */.KO)(store/* currentPageAtom */.ef), 2), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)(), watch = ref3.watch, reset = ref3.reset, control = ref3.control, setValue = ref3.setValue;
    var fields = watch();
    //filtrid
    var toggleCheckbox = function(name, value) {
        setValue(name, !fields[name]);
        var applyFilter = function(filter) {
            setFilters(CustomAttribute_objectSpread({}, filters, CustomAttribute_defineProperty({}, "".concat(attribute), filter)));
            window.scrollTo(0, 0);
        };
        if (fields[name]) {
            applyFilter([]);
        } else {
            setCurrentPage(1);
            applyFilter(CustomAttribute_toConsumableArray(filters["".concat(attribute)]).concat([
                value
            ]));
        }
    };
    (0,react.useEffect)(function() {
        if (filtersReset) {
            reset();
            setCurrentPage(1);
            setTimeout(function() {
                return setFiltersReset(false);
            }, 1000);
        }
    }, [
        filtersReset
    ]);
    (0,react.useEffect)(function() {
        var selectedValues = sortedOptions === null || sortedOptions === void 0 ? void 0 : sortedOptions.filter(function(item) {
            var ref;
            return (ref = Object.values(filters)) === null || ref === void 0 ? void 0 : ref.flat().includes(item.value);
        });
        if (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) {
            selectedValues.forEach(function(item) {
                setValue(item.name, item.value);
            });
        }
    }, [
        filters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterType, {
        title: title,
        children: sortedOptions === null || sortedOptions === void 0 ? void 0 : sortedOptions.map(function(param2) {
            var name = param2.name, label = param2.label, value = param2.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                align: "center",
                justify: "space-between",
                w: 240,
                lineHeight: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        name: name,
                        control: control,
                        defaultValue: false,
                        render: function(param) {
                            var field = param.field;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, CustomAttribute_objectSpread({}, field, {
                                onChange: function() {
                                    return toggleCheckbox(name, value);
                                },
                                label: label,
                                cursor: "pointer"
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "span",
                        pl: 8,
                        color: "lightgray"
                    })
                ]
            }, label);
        })
    });
};

;// CONCATENATED MODULE: ./components/Catalogue/Filter/FilterSidebar.js
function FilterSidebar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FilterSidebar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FilterSidebar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function FilterSidebar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FilterSidebar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FilterSidebar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilterSidebar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FilterSidebar_slicedToArray(arr, i) {
    return FilterSidebar_arrayWithHoles(arr) || FilterSidebar_iterableToArrayLimit(arr, i) || FilterSidebar_unsupportedIterableToArray(arr, i) || FilterSidebar_nonIterableRest();
}
function FilterSidebar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FilterSidebar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FilterSidebar_arrayLikeToArray(o, minLen);
}















function FilterSidebar(_param) {
    var props = _extends({}, _param);
    var router = (0,next_router.useRouter)();
    // Mobile filter
    var ref = FilterSidebar_slicedToArray((0,esm/* useAtom */.KO)(store/* openFilterAtom */.s1), 2), isFilterOpen = ref[0], setOpen = ref[1];
    // Get custom attribute filter options
    var aggregations = useCustomFilterValues();
    var filters = (0,esm/* useAtomValue */.Dv)(store/* filtersAtom */.ot);
    var reset = (0,utils/* useResetAtom */.oC)(store/* filtersAtom */.ot);
    var setFiltersReset = (0,esm/* useSetAtom */.b9)(store/* filtersResetAtom */.Bv);
    var resetFilters = function() {
        reset();
        setFiltersReset(true);
    };
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            // let sliceSourceTarget =
            //   router.asPath.indexOf('?') === -1 ? 0 : router.asPath.indexOf('?');
            // let sourcePath = router.asPath.slice(
            //   10,
            //   sliceSourceTarget ? sliceSourceTarget : router.asPath.length
            // );
            var sliceTargetTarget;
            if (url.includes("?")) {
                return sliceTargetTarget = url.indexOf("?") === -1 ? 0 : url.indexOf("?");
            } else {
                sliceTargetTarget = url.length;
            }
            var targetPath = url.slice(10, sliceTargetTarget);
            if (router.asPath !== targetPath) {
                return resetFilters();
            }
            resetFilters();
            isFilterOpen && setOpen(false);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            return router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, FilterSidebar_objectSpread({
        dir: "column",
        minW: 245,
        mt: {
            _: 64,
            desktop: 48
        }
    }, props, {
        children: [
            filters !== store/* filtersInitialState */.hZ && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                display: "inline-flex",
                pb: "1rem",
                pl: 0,
                onClick: function() {
                    return resetFilters();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* CategoryTitle */.gI, {
                        fontSize: "xsmall",
                        children: "Eemalda filtrid"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "span",
                        role: "img",
                        "aria-label": "Clear filters",
                        hoverOpacity: 0.8,
                        transform: "translateX(25%) translateY(-12%)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {
                            bg: "transparent",
                            stroke: "#45AAC4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryFilter, {}),
            aggregations && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceFilter, {}),
            aggregations === null || aggregations === void 0 ? void 0 : aggregations.slice(2).map(function(item) {
                if (item.attribute_code !== "kuva_avalehel") {
                    var options = item.options.filter(function(param) {
                        var label = param.label;
                        return label !== "-";
                    }).map(function(param) {
                        var label = param.label, value = param.value;
                        return {
                            name: label,
                            label: label,
                            value: value
                        };
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAttributeFilter, {
                        title: item.label.toUpperCase(),
                        attribute: item.attribute_code,
                        options: options
                    }, item.label);
                }
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/mousewheel/mousewheel.js
var mousewheel = __webpack_require__(4224);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
// EXTERNAL MODULE: ./node_modules/@xstyled/system/dist/system.esm.js
var system_esm = __webpack_require__(7248);
;// CONCATENATED MODULE: ./components/Catalogue/Filter/Attributes/Category/CategoryFilterSlider.js
function CategoryFilterSlider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryFilterSlider_templateObject() {
    var data = CategoryFilterSlider_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n\n  .swiper-container {\n    margin-left: unset;\n    margin-right: unset;\n  }\n\n  .swiper-wrapper {\n    transition-timing-function: linear;\n  }\n\n  @media (max-width: desktop) {\n    margin-top: 1rem;\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    right: -0.5rem;\n    width: 40px;\n    height: 30px;\n    background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));\n    z-index: 2;\n\n    @media (max-width: desktop) {\n      right: 0.5rem;\n    }\n  }\n"
    ]);
    CategoryFilterSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryFilterSlider_templateObject1() {
    var data = CategoryFilterSlider_taggedTemplateLiteral([
        "\n  max-width: 98%;\n\n  @media (min-width: desktop) {\n    max-width: 570px;\n  }\n\n  @media (min-width: lg_desktop) {\n    max-width: 680px;\n  }\n\n  .swiper-slide {\n    max-width: min-content;\n  }\n"
    ]);
    CategoryFilterSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryFilterSlider_templateObject2() {
    var data = CategoryFilterSlider_taggedTemplateLiteral([
        "\n  font-size: xsmall;\n  color: black;\n  border: 1px solid ",
        ";\n  border-radius: 15px;\n  padding: 2px 14px;\n  white-space: nowrap;\n\n  &:hover,\n  &:active {\n    border: 1px solid #96e7e7;\n    cursor: pointer;\n  }\n"
    ]);
    CategoryFilterSlider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







core_class/* default.use */.Z.use([
    mousewheel/* default */.Z,
    autoplay/* default */.Z
]);
var SliderContainer = styled_components_esm/* default.divBox */.ZPm.divBox(CategoryFilterSlider_templateObject());
var AutoPlaySlider = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(CategoryFilterSlider_templateObject1());
var CategoryLabel = styled_components_esm/* default.divBox */.ZPm.divBox(CategoryFilterSlider_templateObject2(), system_esm.th.color("purple-100"));
function FilterSlider(param1) {
    var categories = param1.categories;
    var sliderRef = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var categoryPath = function(urlKey) {
        return "".concat(router.asPath, "/").concat(urlKey);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoPlaySlider, {
            ref: sliderRef,
            slidesPerView: "auto",
            spaceBetween: 16,
            mousewheel: {
                sensitivity: 50
            },
            speed: 8000,
            autoplay: {
                delay: 0
            },
            loop: (categories === null || categories === void 0 ? void 0 : categories.length) >= 6 && true,
            resizeObserver: true,
            resistance: false,
            children: categories.map(function(param) {
                var name = param.name, url_key = param.url_key;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: categoryPath(url_key),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLabel, {
                                children: name
                            })
                        })
                    })
                }, url_key);
            })
        })
    });
};

// EXTERNAL MODULE: ./hooks/UI/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(2291);
// EXTERNAL MODULE: ./components/UI/Dismiss/index.js
var Dismiss = __webpack_require__(5510);
;// CONCATENATED MODULE: ./components/Catalogue/Filter/MobileFilter.js
function MobileFilter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function MobileFilter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MobileFilter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileFilter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function MobileFilter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileFilter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileFilter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function MobileFilter_slicedToArray(arr, i) {
    return MobileFilter_arrayWithHoles(arr) || MobileFilter_iterableToArrayLimit(arr, i) || MobileFilter_unsupportedIterableToArray(arr, i) || MobileFilter_nonIterableRest();
}
function MobileFilter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MobileFilter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileFilter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileFilter_arrayLikeToArray(o, minLen);
}
function MobileFilter_templateObject() {
    var data = MobileFilter_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100vw;\n  /* min-height: calc(100% + 60px); */\n  height: calc(100% + 60px);\n  padding: 3rem 2rem;\n  background-color: white;\n  overflow-x: hidden;\n  z-index: 5;\n  animation: 0.5s in-out forwards;\n\n  @keyframes in-out {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  .filter {\n    font-size: medium;\n    font-weight: bold;\n    display: block;\n    margin: auto;\n  }\n"
    ]);
    MobileFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var FilterFlyOut = styled_components_esm/* default.aside */.ZPm.aside(MobileFilter_templateObject());
function MobileFilter() {
    var ref = MobileFilter_slicedToArray((0,esm/* useAtom */.KO)(store/* openFilterAtom */.s1), 2), isFilterOpen = ref[0], setOpen = ref[1];
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    // Set overflow-y hidden when filter open
    (0,useLockBodyScroll/* default */.Z)(isFilterOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterFlyOut, {
        open: isFilterOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dismiss/* default */.Z, {
                        "aria-label": "Close filter",
                        onClick: function() {
                            return setOpen(false);
                        },
                        ml: "-0.5rem",
                        mt: "0.5rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "filter",
                        children: t("filter.mobile_apply_filter")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSidebar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexColCenter */.S, {
                pt: "3rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileButton, {
                    onClick: function() {
                        return setOpen(false);
                    },
                    w: {
                        _: "80%",
                        sm_tablet: "50%"
                    },
                    border: "1px solid black",
                    children: t("filter.mobile_apply_filter")
                })
            })
        ]
    });
};
var MobileButton = function(_param) {
    var children = _param.children, rest = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, MobileFilter_objectSpread({
        bg: "transparent",
        padding: "0.5rem 2rem",
        margin: {
            _: "1rem 0 1rem 0"
        },
        display: {
            desktop: "none"
        }
    }, rest, {
        children: children
    }));
};

// EXTERNAL MODULE: ./components/Catalogue/Products.js
var Products = __webpack_require__(2792);
// EXTERNAL MODULE: ./components/Catalogue/Sort/index.js + 1 modules
var Sort = __webpack_require__(9999);
// EXTERNAL MODULE: ./components/UI/Breadcrumbs/index.js
var Breadcrumbs = __webpack_require__(2524);
// EXTERNAL MODULE: ./components/UI/Icons/Catalogue/index.js
var Catalogue = __webpack_require__(5862);
;// CONCATENATED MODULE: ./components/UI/Button/Filter.js






function FilterButton() {
    var setFilterOpen = (0,esm/* useSetAtom */.b9)(store/* openFilterAtom */.s1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
        display: {
            desktop: "none"
        },
        justifySelf: {
            _: "flex-start",
            mobile: "flex-end"
        },
        alignSelf: {
            _: "flex-start",
            mobile: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
            onClick: function() {
                return setFilterOpen(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "filter",
                    role: "img",
                    "aria-label": "Filter",
                    children: Catalogue/* Filter */.wn
                }),
                "\xa0 Filtreeri"
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/UI/Layout/index.js
var Layout = __webpack_require__(3793);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./components/UI/Button/Variants/Monochrome.js
var Monochrome = __webpack_require__(7013);
// EXTERNAL MODULE: ./components/UI/Loader/index.js
var Loader = __webpack_require__(1395);
// EXTERNAL MODULE: ./components/Catalogue/styles.js
var styles = __webpack_require__(3862);
// EXTERNAL MODULE: ./hooks/products/usePagination.js
var usePagination = __webpack_require__(8510);
// EXTERNAL MODULE: ./components/Catalogue/Pagination.js
var Pagination = __webpack_require__(234);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var interweave_esm = __webpack_require__(3108);
// EXTERNAL MODULE: ./utils/parseHTML.js
var parseHTML = __webpack_require__(5029);
// EXTERNAL MODULE: ./components/UI/Error/ErrorLayout.js
var ErrorLayout = __webpack_require__(517);
;// CONCATENATED MODULE: ./pages/kataloog/[[...kategooria]].js
function _kategooria_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _kategooria_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _kategooria_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _kategooria_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _kategooria_slicedToArray(arr, i) {
    return _kategooria_arrayWithHoles(arr) || _kategooria_iterableToArrayLimit(arr, i) || _kategooria_unsupportedIterableToArray(arr, i) || _kategooria_nonIterableRest();
}
function _kategooria_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _kategooria_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _kategooria_arrayLikeToArray(o, minLen);
}
































var __N_SSP = true;
function _kategooria_Catalogue(param) {
    var id = param.id, categories = param.categories, allCategories = param.allCategories, name = param.name, description = param.description, meta_description = param.meta_description, meta_title = param.meta_title;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var ref = (0,useCatalogue/* default */.Z)(), products = ref.products, loading = ref.loading, pages = ref.pages, count = ref.count;
    var ref1 = _kategooria_slicedToArray((0,esm/* useAtom */.KO)(store/* pageSizeAtom */.Gx), 2), pageSize = ref1[0], setPageSize = ref1[1];
    var crumbs = useBreadcrumbs();
    var crumbsSchema = crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(function(crumb, i) {
        return {
            "@type": "ListItem",
            position: i + 1,
            name: crumb.name,
            item: "baltbaby.com".concat(crumb.path)
        };
    });
    var ref2 = _kategooria_slicedToArray((0,esm/* useAtom */.KO)(store/* currentPageAtom */.ef), 2), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = _kategooria_slicedToArray((0,esm/* useAtom */.KO)(store/* openFilterAtom */.s1), 1), isMobileFilterOpen = ref3[0];
    // Restore scroll position when returning from a product
    (0,useScrollRestoration/* default */.Z)({
        data: products
    });
    (0,usePagination/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: id ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            categories: allCategories,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                    seo: {
                        title: meta_title ? meta_title : "".concat(name, " - Baltbaby"),
                        description: meta_description !== null && meta_description !== void 0 ? meta_description : "Baltbaby ".concat(name === null || name === void 0 ? void 0 : name.toLowerCase(), " kategooriast leiate suure valiku kvaliteetseid beebikaupu. Telli ").concat(name === null || name === void 0 ? void 0 : name.toLowerCase(), " otse koju v\xf5i tule ise j\xe4rele.")
                    }
                }),
                crumbsSchema.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    type: "application/ld+json",
                    id: "baltbaby_catalogue_structured_data",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            itemListElement: crumbsSchema
                        })
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            crumbs: crumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CatalogueContainer */.F, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSidebar, {
                                    display: {
                                        _: "none",
                                        desktop: "flex"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ResultsContainer */.O, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitleSmall */.Kg, {
                                            as: "h1",
                                            pb: "2rem",
                                            children: name
                                        }),
                                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(interweave_esm/* Markup */.Lu, {
                                            content: (0,parseHTML/* default */.Z)(description),
                                            blockList: ([
                                                "div"
                                            ], [
                                                "p"
                                            ]),
                                            nowrap: true
                                        }),
                                        (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                            display: {
                                                desktop: "flex"
                                            },
                                            align: {
                                                desktop: "center"
                                            },
                                            spaceX: {
                                                desktop: "1rem"
                                            },
                                            mt: "2rem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        t("category.subcategory"),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSlider, {
                                                    categories: categories
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                            id: "product_container",
                                            dir: {
                                                _: "column",
                                                mobile: "row"
                                            },
                                            justify: {
                                                mobile: "space-between",
                                                desktop: "flex-end"
                                            },
                                            mt: "2rem",
                                            whiteSpace: "nowrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {}),
                                                isMobileFilterOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilter, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Products/* default */.Z, {
                                            products: products
                                        }),
                                        (products === null || products === void 0 ? void 0 : products.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: pages > 0 && count > 24 && products && (products === null || products === void 0 ? void 0 : products.length) !== count && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                                                dir: "column",
                                                align: "center",
                                                alignSelf: "center",
                                                position: "relative",
                                                mt: 42,
                                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : products.length < 100 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    pages: pages
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Monochrome/* default */.Z, {
                                                    py: 8,
                                                    px: {
                                                        _: 32,
                                                        desktop: 56
                                                    },
                                                    onClick: function() {
                                                        setCurrentPage(currentPage + 1);
                                                        setPageSize(pageSize + 24);
                                                    },
                                                    children: t("review.show_more")
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: (products === null || products === void 0 ? void 0 : products.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                                align: "center",
                                                maxW: {
                                                    _: 300,
                                                    desktop: 340
                                                },
                                                p: "10px 20px",
                                                spaceX: 20,
                                                bg: "#F7F7F7",
                                                borderRadius: 7,
                                                fontWeight: 700,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                                        as: "span",
                                                        role: "img",
                                                        transform: "translateY(8%)",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Catalogue/* ZeroProducts */.LB, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("category.no_products_filter")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            categories: allCategories,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLayout/* default */.Z, {
                statusCode: "404",
                title: "404: This page could not be found",
                text: t("pages.not_found"),
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Sad404Teddy */.Vt, {})
            })
        })
    });
};


/***/ }),

/***/ 4244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCategoryId; }
/* harmony export */ });
/* harmony import */ var global_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6863);

function getCategoryId(slug) {
    var category1 = global_data__WEBPACK_IMPORTED_MODULE_0__/* .categories.find */ .bd.find(function(category) {
        return category.url_key === slug;
    });
    var id = category1 === null || category1 === void 0 ? void 0 : category1.id.toString();
    return id;
};


/***/ }),

/***/ 5029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseHTML; }
/* harmony export */ });
function parseHTML(content) {
    return content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
};


/***/ }),

/***/ 7649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6156);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-underscore-dangle: "off" */


var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .nextTick */ .Y3)(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      autoplay: _extends({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,9447,5230,3108,40,2483,5275,1979,9085,8435,1459,883,9774,2888,179], function() { return __webpack_exec__(2982); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);